import { SideMenuTypes } from '../types';

export const setSideMenuExpanded = () => ({
  type: SideMenuTypes.SET_EXPANDED,
  payload: null
});
